import type { CSSAnchorAttributes } from "@circle-react/helpers/cssAnchorHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

export interface RightProps {
  anchorProps?: CSSAnchorAttributes;
  children?: ReactNode;
  className?: string;
  hidden?: boolean;
}

/**
 * Renders the right rail when its nearest container query ancestor is
 * wider than 768px. Consumers MUST place an ancestor with
 * `[container-type:inline-size]` (e.g. `HomepageContentWrapper` does this
 * under the AppShell FF) — without it, the `@container` query never
 * matches and the rail stays hidden with no error.
 */
export const PageRightRail = ({
  className,
  children,
  hidden = false,
  anchorProps,
}: RightProps) => {
  if (hidden) return null;

  return (
    <aside
      aria-label={t("right_sidebar")}
      className={classNames(
        "hidden w-80 shrink-0 [@container(min-width:768px)]:block",
        className,
      )}
      data-testid="sidebar-right"
      {...anchorProps}
    >
      <div className="w-80 overflow-hidden" data-draggable="false">
        {children}
      </div>
    </aside>
  );
};

export const Right = PageRightRail;
